import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Swipeable from 'react-swipeable';

import BackIcon from '@material-ui/icons/ArrowBackIosOutlined';
import ForwardIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import IconButton from '@material-ui/core/IconButton';

import {Loading} from '../../common';

class SlideShow extends React.Component {
    constructor() {
        super();

        this.getDuration = this.getDuration.bind(this);
        this.goToSlide = this.goToSlide.bind(this);
        this.handleOnLoad = this.handleOnLoad.bind(this);
        this.nextSlide = this.nextSlide.bind(this);
        this.previousSlide = this.previousSlide.bind(this);
        this.resetLoadedIndices = this.resetLoadedIndices.bind(this);
        this.setTimer = this.setTimer.bind(this);

        this.state = {
            currentIndex: null,
            loadedIndices: [],
            mediaLoaded: false,
            previousIndex: null
        };

        this.timer = null;
    }

    componentWillMount() {
        if (this.props.slides.length > 1) {
            this.resetLoadedIndices();
            this.setTimer(0, true);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {loadedIndices} = this.state;
        const {slides, waitForMedia} = this.props;

        const mediaLoaded = slides.every((slide, index) => loadedIndices[index]);

        if (waitForMedia && !prevState.mediaLoaded && mediaLoaded) {
            this.goToSlide(0);
            this.setState({mediaLoaded: true});
        } else if (!waitForMedia && !prevProps.slides.length) {
            this.goToSlide(0);
        } else if (!waitForMedia && prevProps.slides.length > 1 && slides.length <= 1) {
            this.setState({currentIndex: 0, previousIndex: null});
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        clearTimeout(this.timer);
    }

    getDuration(index) {
        return this.props.dynamicDuration && this.props.slides[index].props.duration
            ? Number.parseInt(this.props.slides[index].props.duration, 10) * 1000
            : this.props.duration;
    }

    goToSlide(nextIndex, previousIndex, resetTimer) {
        if (!!this.props.beforeSlideChange) {
            this.props.beforeSlideChange();
        }

        if (this.props.slides.length) {
            this.setState({
                currentIndex: nextIndex,
                previousIndex: previousIndex !== nextIndex ? previousIndex : null
            });
        }

        if (this.props.dynamicDuration || !this.timer || resetTimer) {
            this.setTimer(nextIndex);
        }

        if (!!this.props.afterSlideChange) {
            this.props.afterSlideChange();
        }
    }

    handleOnLoad(index) {
        const loadedIndices = [...this.state.loadedIndices];
        loadedIndices[index] = true;
        this.setState({loadedIndices});
    }

    nextSlide(resetTimer) {
        const currentIndex = this.state.currentIndex;
        const nextIndex = (currentIndex + 1) % this.props.slides.length;
        this.goToSlide(nextIndex, currentIndex, resetTimer);
    }

    previousSlide(resetTimer) {
        const currentIndex = this.state.currentIndex;
        const nextIndex = currentIndex - 1 < 0 ? this.props.slides.length - 1 : currentIndex - 1;
        this.goToSlide(nextIndex, currentIndex, resetTimer);
    }

    resetLoadedIndices() {
        const loadedIndices = this.props.slides.map(() => false);
        this.setState({loadedIndices, mediaLoaded: false});
    }

    setTimer(index) {
        clearInterval(this.timer);
        clearTimeout(this.timer);

        if (this.props.slides.length > 1) {
            const duration = this.getDuration(index);

            if (this.props.dynamicDuration) {
                this.timer = setTimeout(this.nextSlide, duration);
            } else {
                this.timer = setInterval(this.nextSlide, duration);
            }
        }
    }

    render() {
        return (
            <div className={classNames('slideshow', { 'has-multiple-pages': this.props.slides.length > 1 })}>
                <div className="slides">
                    {this.props.slides.map((slide, index) => {
                        const duration = this.props.slides.length < 2
                            ? null
                            : this.props.dynamicDuration && slide.props.duration
                                ? slide.props.duration
                                : this.props.duration;
                        return (
                            <slide.component
                                active={this.state.currentIndex === index}
                                deactivating={this.state.previousIndex === index}
                                onLoad={() => this.handleOnLoad(index)}
                                {...slide.props}
                                duration={duration}
                            />
                        );
                    })}
                </div>
                {do {
                    if (this.props.waitForMedia && !this.state.mediaLoaded) {
                        <Loading/>;
                    } else if (this.props.slides.length > 1) {
                        <div>
                            <ul className="slideshow-bullets">
                                {this.props.slides.map((card, index) =>
                                    <li
                                        key={index}
                                        className={classNames({'active': this.state.currentIndex === index})}
                                        onClick={() => this.goToSlide(index, this.state.currentSlide, true)}
                                    >
                                        •
                                    </li>
                                )}
                            </ul>
                            <Swipeable
                                className="controls"
                                onSwipedLeft={() => this.nextSlide(true)}
                                onSwipedRight={() => this.previousSlide(true)}
                                trackMouse
                            >
                                <IconButton onClick={() => this.previousSlide(true)}>
                                    <BackIcon/>
                                </IconButton>
                                <IconButton onClick={() => this.nextSlide(true)}>
                                    <ForwardIcon/>
                                </IconButton>
                            </Swipeable>
                        </div>;
                    }
                }}
            </div>
        );
    }
}

SlideShow.propTypes = {
    afterSlideChange: PropTypes.func,
    autoplay: PropTypes.bool,
    beforeSlideChange: PropTypes.func,
    duration: PropTypes.number,
    dynamicDuration: PropTypes.bool,
    slides: PropTypes.array,
    style: PropTypes.object,
    waitForMedia: PropTypes.bool
};

SlideShow.defaultProps = {
    autoplay: true,
    duration: 5000,
    slides: [],
    waitForMedia: false
};

export default SlideShow;


// WEBPACK FOOTER //
// ./src/components/common/slideshow/SlideShow.js